export const EVENTS_LOCATOR_BUILDER_COMPONENT_NAME = "EventsLocator";
